export default "__VITE_ASSET__FK2FBa4___"